import { colorHelpers } from "@/utils/colorHelpers";

export function ProgressBar({ steps, current, color }: {
    steps: { id: string; label: string }[];
    current: number;
    color: string;
}) {
    const c = colorHelpers(color);
    return (
        <div>
            <div className="flex items-center justify-center gap-1">
                {steps.map((s, i) => (
                    <div key={s.id} className="flex items-center">
                        <div className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-semibold transition-colors ${i <= current ? `${c.bg} text-white` : 'bg-gray-200 text-gray-500'
                            }`}>
                            {i < current
                                ? <i className="ri-check-line text-xs" />
                                : i + 1
                            }
                        </div>
                        {i < steps.length - 1 && (
                            <div className={`w-8 h-1 mx-1 rounded transition-colors ${i < current ? c.bg : 'bg-gray-200'}`} />
                        )}
                    </div>
                ))}
            </div>
            <div className="flex justify-center gap-4 mt-3 text-xs text-gray-400 flex-wrap">
                {steps.map((s, i) => (
                    <span key={s.id} className={i <= current ? `${c.text} font-medium` : ''}>{s.label}</span>
                ))}
            </div>
        </div>
    );
}